import React, { useState } from 'react';
import ViewLayout2 from '../../components/ui/ViewLayout2';
import { Card } from '../../components/ui/BaseComponents';
import CoursesTab from './tabs/CoursesTab';
import QuizzesTab from './tabs/QuizzesTab';
import ParticipantsTab from './tabs/ParticipantsTab';
import BugReportsTab from './tabs/BugReportsTab';

const TABS = {
  COURSES: 'courses',
  QUIZZES: 'quizzes',
  PARTICIPANTS: 'participants',
  BUG_REPORTS: 'bug-reports'
};

function AdminDashboardV2() {
  const [activeTab, setActiveTab] = useState(TABS.COURSES);

  const renderTabContent = () => {
    switch (activeTab) {
      case TABS.COURSES:
        return <CoursesTab />;
      case TABS.QUIZZES:
        return <QuizzesTab />;
      case TABS.PARTICIPANTS:
        return <ParticipantsTab />;
      case TABS.BUG_REPORTS:
        return <BugReportsTab />;
      default:
        return <CoursesTab />;
    }
  };

  return (
    <ViewLayout2
      title="Admin Dashboard"
      onBack="/dashboard"
      maxWidth="7xl"
    >
      {/* Tab Navigation */}
      <Card className="mb-6">
        <div className="flex border-b border-border">
          <button
            onClick={() => setActiveTab(TABS.COURSES)}
            className={`flex-1 px-6 py-3 text-sm font-medium theme-transition ${
              activeTab === TABS.COURSES
                ? 'border-b-2 border-blue-500 text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20'
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-800/50'
            }`}
          >
            Kurse
          </button>
          <button
            onClick={() => setActiveTab(TABS.QUIZZES)}
            className={`flex-1 px-6 py-3 text-sm font-medium theme-transition ${
              activeTab === TABS.QUIZZES
                ? 'border-b-2 border-blue-500 text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20'
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-800/50'
            }`}
          >
            Quizzes
          </button>
          <button
            onClick={() => setActiveTab(TABS.PARTICIPANTS)}
            className={`flex-1 px-6 py-3 text-sm font-medium theme-transition ${
              activeTab === TABS.PARTICIPANTS
                ? 'border-b-2 border-blue-500 text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20'
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-800/50'
            }`}
          >
            Teilnehmer
          </button>
          <button
            onClick={() => setActiveTab(TABS.BUG_REPORTS)}
            className={`flex-1 px-6 py-3 text-sm font-medium theme-transition ${
              activeTab === TABS.BUG_REPORTS
                ? 'border-b-2 border-blue-500 text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20'
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-800/50'
            }`}
          >
            Fehlerberichte
          </button>
        </div>
      </Card>

      {/* Tab Content */}
      {renderTabContent()}
    </ViewLayout2>
  );
}

export default AdminDashboardV2;
